import React, { useEffect, useState } from "react"
import { Button, Col, Container, Form, Row, Spinner, Toast, ToastContainer } from "react-bootstrap"
import { useParams } from 'react-router-dom'

import AssessmentStep0 from "./AssessmentStep0";
import AssessmentStep1 from "./AssessmentStep1";
import AssessmentStep2 from "./AssessmentStep2";
import AssessmentStep3 from "./AssessmentStep3";
import AssessmentStep4 from "./AssessmentStep4";
import AssessmentStep5 from "./AssessmentStep5";
import AssessmentStep6 from "./AssessmentStep6";
import AssessmentStep7 from "./AssessmentStep7";
import AssessmentPrograms from "./AssessmentPrograms"
import AssessmentSubmit from "./AssessmentSubmit";

import { formatAssessmentPostData } from '../../../lib/postAssessment'
import { formatAssessmentPutData } from "../../../lib/putAssessment"

import { useSearchParams } from "react-router-dom"

import { ASSESSMENT_PERIOD } from "../../../fastConstants";

const STEP_SELECT_PROGRAMS = 0
const STEP_STEP_0 = 1
const STEP_STEP_1 = 2
const STEP_STEP_2 = 3
const STEP_STEP_3 = 4
const STEP_STEP_4 = 5
const STEP_STEP_5 = 6
const STEP_STEP_6 = 7
const STEP_STEP_7 = 8
const STEP_STEP_8 = 9

const TITLE_STEP_1='Step 1: Identify Focus Area'
const TITLE_STEP_2='Step 2: Design or Adapt Assessment Tools'
const TITLE_STEP_3='Step 3: Conduct Assessment'
const TITLE_STEP_4='Step 4: Analyze the Collected Data - Round 1'
const TITLE_STEP_5='Step 5: Design and Plan Changes'
const TITLE_STEP_6='Step 6: Implement Changes and Assess Again'
const TITLE_STEP_7='Step 7: Reflect & Conclude'

const SAVE_ON_NEXT_ENABLED = false

const DEFAULT_ACTIVE_PROGRAMS = {}
const FAST_URL = process.env.REACT_APP_DS_API_URL
const BASE_URL = FAST_URL + "/assessments/"
const SAVE_REMINDER_MESSAGE = "To save your changes, please click Save."

export default function AssessmentHomePage(props) {
    const currentUser = props.username
    const [mode, setMode] = useState(props.mode)
    const [searchParams] = useSearchParams()
    const [currentStep, setCurrentStep] = useState(0)
    const [showToast, setShowToast] = useState(false)
    const [saveInProgress, setSaveInProgress] = useState(false)
    const [assessmentId, setAssessmentId] = useState(useParams()?.assessmentId)

    const [assessment, setAssessment] = useState({})


    const [department, setDepartment] = useState()
    const [departmentId, setDepartmentId] = useState()
    const [theme, setTheme] = useState()
    const [activePrograms, setActivePrograms] = useState(DEFAULT_ACTIVE_PROGRAMS)
    const [submittedPrograms, setSubmittedPrograms] = useState()
    const [submittedUsers, setSubmittedUsers] = useState()
    const [submittedDates, setSubmittedDates] = useState()
    const [programLearningOutcomes, setProgramLearningOutcomes] = useState({})

    // Step 1
    const [step1DataStore, setStep1DataStore] = useState({})
    const [step1CompletionData, setStep1CompletionData] = useState({})

    // Step 2
    const [sloAnalysisStore, setSloAnalysisStore] = useState({})
    const [step2CompletionData, setStep2CompletionData] = useState({})

    // Step 3
    const [step3DataStore, setStep3DataStore] = useState({})
    const [step3CompletionData, setStep3CompletionData] = useState({})

    // Step 4
    const [step4DataStore, setStep4DataStore] = useState({})
    const [step4CompletionData, setStep4CompletionData] = useState({})

    // Step 5
    const [step5Tab1DataStore, setStep5Tab1DataStore] = useState({})
    const [step5Tab2DataStore, setStep5Tab2DataStore] = useState({})
    const [step5CompletionData, setStep5CompletionData] = useState({})

    // Step 6
    const [step6DataStore, setStep6DataStore] = useState({})
    const [step6CompletionData, setStep6CompletionData] = useState({})

    // Step 7
    const [step7Tab1DataStore, setStep7Tab1DataStore] = useState({})
    const [step7Tab2DataStore, setStep7Tab2DataStore] = useState({})
    const [step7CompletionData, setStep7CompletionData] = useState({})
    const [step7Tab2CompletionData, setStep7Tab2CompletionData] = useState({})

    const [mappedSlos, setMappedSlos] = useState({})

    const [errorFound, setErrorFound] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    useEffect(() => {
        if (mode == "modify" && assessmentId) {
            let url = BASE_URL + assessmentId
            fetch(url)
            .then(response => {
                return response.json()
            })
            .then(data => {
                setAssessment(data)
                setStep1DataStore(initStep1Data(data))
                setSloAnalysisStore(initStep2Data(data))
                setStep3DataStore(initStep3Data(data))
                setStep4DataStore(initStep4Data(data))
                setStep5Tab1DataStore(initStep5Tab1Data(data))
                setStep5Tab2DataStore(initStep5Tab2Data(data))
                setStep6DataStore(initStep6Data(data))
                setStep7Tab1DataStore(initStep7Tab1Data(data))
                setStep7Tab2DataStore(initStep7Tab2Data(data))
                setDepartmentId(data.departmentId)
            })
            .catch(err => {
                console.log(err)
            })
        }
    }, [assessmentId, mode])

    useEffect(() => {
        if (mode == 'create') {
            let step1Programs = {}
            let step2Programs = {}
            let step3Programs = {}
            let step3ProgramsCompletions = {}
            let step4Programs = {}
            let step5Programs = {}
            let step6Programs = {}
            let step6ProgramCompletions = {}
            let step7Programs = {}
            let step7ProgramsCompletions = {}
            let step7Tab2ProgramCompletions = {}
            for (var key in activePrograms) {
                step1Programs[key] = {}
                step2Programs[key] = {}
                step3Programs[key] = {}
                step3ProgramsCompletions[key] = {}
                step4Programs[key] = {}
                step5Programs[key] = {}
                step6Programs[key] = {}
                step6ProgramCompletions[key] = {}
                step7Programs[key] = {}
                step7ProgramsCompletions[key] = {}
                step7Tab2ProgramCompletions[key] = {}
            }
            setStep1CompletionData({...step1Programs})
            setStep2CompletionData({...step2Programs})
            setStep3DataStore({...step3Programs})
            setStep3CompletionData({...step3ProgramsCompletions})
            setStep4CompletionData({...step4Programs})
            setStep5CompletionData({...step5Programs})
            setStep6DataStore({...step6Programs})
            setStep6CompletionData({...step6ProgramCompletions})
            setStep7Tab2DataStore({...step7Programs})
            setStep7CompletionData({...step7ProgramsCompletions})
            setStep7Tab2CompletionData({...step7Tab2ProgramCompletions})
        }
    }, [activePrograms])

    useEffect(() => {
        if (departmentId || searchParams.get('d')) {
            let url = BASE_URL
            if (departmentId) {
                url = url + '?departmentId=' + departmentId
            } else {
                url = url + '?departmentId=' + searchParams.get('d')
            }
            url = url + '&reviewYear=' + ASSESSMENT_PERIOD
            
            fetch(url)
            .then(response => {
                return response.json()
            })
            .then(data => {
                setDepartment(data)
            })
            .catch(err => {
                console.log(err)
            })
        }
    }, [departmentId, searchParams.get('d')])

    useEffect(() => {
        if (departmentId || searchParams.get('d')) {
            let deptId = departmentId
            if (!departmentId) {
                deptId = searchParams.get('d')
            }

            let url = FAST_URL + `/learning-outcome/active/${deptId}`
            
            fetch(url)
            .then(response => {
                return response.json()
            })
            .then(data => {
                let currentSlos = {...programLearningOutcomes}
                currentSlos[deptId] = data
                setProgramLearningOutcomes({...currentSlos})
            })
            .catch(err => {
                console.log(err)
            })
        }
    }, [departmentId])

    useEffect(() => {
        let url = FAST_URL + "/themes/current"
        
        fetch(url)
        .then(response => {
            return response.json()
        })
        .then(data => {
            setTheme(data)
        })
        .catch(err => {
            console.log(err)
        })
    }, [])

    useEffect(() => {
        let url = FAST_URL + "/mappings/"
        
        if (departmentId || searchParams.get('d')) {
            if (departmentId) {
                url = url + departmentId
            } else {
                url = url + searchParams.get('d')
            }

            url = url + '?reviewYear=' + ASSESSMENT_PERIOD
            
            fetch(url)
            .then(response => {
                return response.json()
            })
            .then(data => {
                const mapCache = {}
                data.forEach(obj => {
                    if (!(obj.programId in mapCache)) {
                        mapCache[obj.programId] = {}
                    }
                    mapCache[obj.programId][obj.learningOutcome] = obj
                })
                setMappedSlos(mapCache)
            })
            .catch(err => {
                console.log(err)
            })
        }
    }, [departmentId])

    const initStep1Data = (data) => {
        let s1data = {}
        data.programAssessments.forEach((assessment) => {
            if (!(assessment.programId in s1data)) {
                s1data[assessment.programId] = {}
            }
            let s1AssessmentData = assessment.step1Data
            if (s1AssessmentData?.learningOutcomes) {
                s1AssessmentData.learningOutcomes.forEach((sloData) => {
                    if (!(sloData.sloId in s1data[assessment.programId])) {
                        s1data[assessment.programId][sloData.sloId] = {}
                    }
    
                    let sData = s1data[assessment.programId][sloData.sloId]
                    sData['s1q1'] = sloData.focusQuestion
                })
            }
            
            if (!(assessment.programId in step1CompletionData)) {
                step1CompletionData[assessment.programId] = {}
            }

            step1CompletionData[assessment.programId].completed = s1AssessmentData?.completed
            step1CompletionData[assessment.programId].dateCompleted = s1AssessmentData?.dateCompleted
            step1CompletionData[assessment.programId].completedBy = s1AssessmentData?.completedBy

            step1CompletionData[assessment.programId].createdBy = s1AssessmentData?.createdBy
            step1CompletionData[assessment.programId].dateCreated = s1AssessmentData?.dateCreated
            step1CompletionData[assessment.programId].modifiedBy = s1AssessmentData?.modifiedBy
            step1CompletionData[assessment.programId].dateModified = s1AssessmentData?.dateModified
        })
        return s1data
    }

    const initStep2Data = (data) => {
        let s2data = {}
        data.programAssessments.forEach((assessment) => {
            if (!(assessment.programId in s2data)) {
                s2data[assessment.programId] = {}
            }
            let s2AssessmentData = assessment.step2Data
            if (s2AssessmentData?.learningOutcomes) {
                s2AssessmentData?.learningOutcomes.forEach((sloData) => {
                    if (!(sloData.sloId in s2data[assessment.programId])) {
                        s2data[assessment.programId][sloData.sloId] = {}
                    }
    
                    let sData = s2data[assessment.programId][sloData.sloId]
                    sData['toolDescription'] = sloData.toolDescription
                    sData['coursesAssessed'] = sloData.coursesAssessed
                    sData['brightspaceAutomation'] = sloData.brightspaceAutomation
                    sData['hypotheticalAnalysis'] = sloData.hypotheticalAnalysis
                })
            }

            if (!(assessment.programId in step2CompletionData)) {
                step2CompletionData[assessment.programId] = {}
            }
    
            step2CompletionData[assessment.programId].completed = s2AssessmentData?.completed
            step2CompletionData[assessment.programId].dateCompleted = s2AssessmentData?.dateCompleted
            step2CompletionData[assessment.programId].completedBy = s2AssessmentData?.completedBy

            step2CompletionData[assessment.programId].createdBy = s2AssessmentData?.createdBy
            step2CompletionData[assessment.programId].dateCreated = s2AssessmentData?.dateCreated
            step2CompletionData[assessment.programId].modifiedBy = s2AssessmentData?.modifiedBy
            step2CompletionData[assessment.programId].dateModified = s2AssessmentData?.dateModified
        })
        return s2data
    }

    // We need to store step 3 and 6 as program data and not learning outcome data.
    const initStep3Data = (data) => {
        let s3data = {}
        data.programAssessments.forEach((assessment) => {
            if (!(assessment.programId in s3data)) {
                s3data[assessment.programId] = {}
            }
            let s3AssessmentData = assessment.step3Data
            if (s3AssessmentData) {
                s3data[assessment.programId]['s3q1'] = s3AssessmentData?.assessmentToolUsed
            }

            if (!(assessment.programId in step3CompletionData)) {
                step3CompletionData[assessment.programId] = {}
            }
            step3CompletionData[assessment.programId].completed = s3AssessmentData?.completed
            step3CompletionData[assessment.programId].dateCompleted = s3AssessmentData?.dateCompleted
            step3CompletionData[assessment.programId].completedBy = s3AssessmentData?.completedBy

            step3CompletionData[assessment.programId].createdBy = s3AssessmentData?.createdBy
            step3CompletionData[assessment.programId].dateCreated = s3AssessmentData?.dateCreated
            step3CompletionData[assessment.programId].modifiedBy = s3AssessmentData?.modifiedBy
            step3CompletionData[assessment.programId].dateModified = s3AssessmentData?.dateModified
        })
        return s3data
    }

    const initStep4Data = (data) => {
        let s4data = {}
        data.programAssessments.forEach((assessment) => {
            if (!(assessment.programId in s4data)) {
                s4data[assessment.programId] = {}
            }
            let s4AssessmentData = assessment.step4Data
            if (s4AssessmentData?.learningOutcomes) {
                s4AssessmentData?.learningOutcomes.forEach((sloData) => {
                    if (!(sloData.sloId in s4data[assessment.programId])) {
                        s4data[assessment.programId][sloData.sloId] = {}
                    }
    
                    let sData = s4data[assessment.programId][sloData.sloId]
                    // TODO: Change to use backend JSON attribute name
                    sData["summaryOfResults"] = sloData.resultsSummary
                    // TODO: Change to use backend JSON attribute name
                    sData["reflectionOnHypothesis"] = sloData.focusAreaReflection
                    sData["interpretationOfResults"] = sloData.interpretationOfResults
                    sData["followUpQuestions"] = sloData.followUpQuestions
                    sData["actionsForImprovement"] = sloData.actionsForImprovement
                })
            }
            
            if (!(assessment.programId in step4CompletionData)) {
                step4CompletionData[assessment.programId] = {}
            }
    
            step4CompletionData[assessment.programId].completed = s4AssessmentData?.completed
            step4CompletionData[assessment.programId].dateCompleted = s4AssessmentData?.dateCompleted
            step4CompletionData[assessment.programId].completedBy = s4AssessmentData?.completedBy

            step4CompletionData[assessment.programId].createdBy = s4AssessmentData?.createdBy
            step4CompletionData[assessment.programId].dateCreated = s4AssessmentData?.dateCreated
            step4CompletionData[assessment.programId].modifiedBy = s4AssessmentData?.modifiedBy
            step4CompletionData[assessment.programId].dateModified = s4AssessmentData?.dateModified
        })
        return s4data
    }

    const initStep5Tab1Data = (data) => {
        let s5data = {}
        data.programAssessments.forEach((assessment) => {
            if (!(assessment.programId in s5data)) {
                s5data[assessment.programId] = {}
            }
            
            let s5AssessmentData = assessment.step5Data
            if (s5AssessmentData?.learningOutcomes) {
                s5AssessmentData?.learningOutcomes.forEach((sloData) => {
                    if (!(sloData.sloId in s5data[assessment.programId])) {
                        s5data[assessment.programId][sloData.sloId] = {}
                    }
    
                    let sData = s5data[assessment.programId][sloData.sloId]
                    sData["s5q30"] = sloData.cycleSecondDataCollection
                    sData["s5q1"] = sloData.changesPlanned
                    sData["s5q2"] = sloData.dataMotivation
                    sData["s5q3"] = sloData.changeHypothesis
                    sData["s5q4"] = sloData.changeInApproach
                    sData["s5q5"] = sloData.changesInFaculty
                    sData["s5q15"] = sloData.facultyCommunicationAboutChange
                    sData["s5q6"] = sloData.approachToolChanges
                    sData["s5q7"] = sloData.facultyDevelopment
                    sData["s5q8"] = sloData.courseContentChanges
                    sData["s5q9"] = sloData.courseSequencePrerequisiteChanges
                    sData["s5q10"] = sloData.gradingMethodologyChanges
                    sData["s5q11"] = sloData.assignmentRevisionChanges
                    sData["s5q12"] = sloData.budgetaryReallocationChanges
                    sData["s5q13"] = sloData.otherChanges
                })
            }

            if (!(assessment.programId in step5CompletionData)) {
                step5CompletionData[assessment.programId] = {}
            }
    
            step5CompletionData[assessment.programId].completed = s5AssessmentData?.completed
            step5CompletionData[assessment.programId].dateCompleted = s5AssessmentData?.dateCompleted
            step5CompletionData[assessment.programId].completedBy = s5AssessmentData?.completedBy

            step5CompletionData[assessment.programId].createdBy = s5AssessmentData?.createdBy
            step5CompletionData[assessment.programId].dateCreated = s5AssessmentData?.dateCreated
            step5CompletionData[assessment.programId].modifiedBy = s5AssessmentData?.modifiedBy
            step5CompletionData[assessment.programId].dateModified = s5AssessmentData?.dateModified
        })
        return s5data
    }

    const initStep5Tab2Data = (data) => {
        let s5data = {}
        data.programAssessments.forEach((assessment) => {
            if (!(assessment.programId in s5data)) {
                s5data[assessment.programId] = {}
            }
            
            let s5AssessmentData = assessment.step5Data
            if (s5AssessmentData?.learningOutcomes) {
                s5AssessmentData?.learningOutcomes.forEach((sloData) => {
                    if (!(sloData.sloId in s5data[assessment.programId])) {
                        s5data[assessment.programId][sloData.sloId] = {}
                    }
    
                    let sData = s5data[assessment.programId][sloData.sloId]
                    sData["s5q17"] = sloData.secondRoundToolDescription
                    sData["s5q18"] = sloData.secondRoundCoursesAssessed
                    sData["s5q19"] = sloData.brightspaceAutomation
                    sData["s5q20"] = sloData.secondRoundDataCollection
                })
            }
            // Completion Info is handled above
        })
        return s5data
    }

    const initStep6Data = (data) => {
        let s6data = {}
        data.programAssessments.forEach((assessment) => {
            if (!(assessment.programId in s6data)) {
                s6data[assessment.programId] = {}
            }
            let s6AssessmentData = assessment.step6Data
            if (s6AssessmentData && s6AssessmentData.secondAssessmentCompleted) {
                s6data[assessment.programId]['s6q1'] = s6AssessmentData.secondAssessmentCompleted
            }
            if (!(assessment.programId in step6CompletionData)) {
                step6CompletionData[assessment.programId] = {}
            }
            step6CompletionData[assessment.programId].completed = s6AssessmentData?.completed
            step6CompletionData[assessment.programId].dateCompleted = s6AssessmentData?.dateCompleted
            step6CompletionData[assessment.programId].completedBy = s6AssessmentData?.completedBy

            step6CompletionData[assessment.programId].createdBy = s6AssessmentData?.createdBy
            step6CompletionData[assessment.programId].dateCreated = s6AssessmentData?.dateCreated
            step6CompletionData[assessment.programId].modifiedBy = s6AssessmentData?.modifiedBy
            step6CompletionData[assessment.programId].dateModified = s6AssessmentData?.dateModified
        })
        return s6data
    }

    const initStep7Tab1Data = (data) => {
        let s7data = {}
        data.programAssessments.forEach((assessment) => {
            if (!(assessment.programId in s7data)) {
                s7data[assessment.programId] = {}
            }
            let s7AssessmentData = assessment.step7Data
            if (s7AssessmentData?.learningOutcomes) {
                s7AssessmentData?.learningOutcomes.forEach((sloData) => {

                    if (!(sloData.sloId in s7data[assessment.programId])) {
                        s7data[assessment.programId][sloData.sloId] = {}
                    }
    
                    let sData = s7data[assessment.programId][sloData.sloId]
                    sData["s7q1"] = sloData.summaryOfResults
                    sData["s7q2"] = sloData.interpretationOfBothRounds
                    sData["s7q3"] = sloData.followUpAndNextSteps
                })
            }

            if (!(assessment.programId in step7CompletionData)) {
                step7CompletionData[assessment.programId] = {}
            }

            step7CompletionData[assessment.programId].completed = s7AssessmentData?.completed
            step7CompletionData[assessment.programId].dateCompleted = s7AssessmentData?.dateCompleted
            step7CompletionData[assessment.programId].completedBy = s7AssessmentData?.completedBy

            step7CompletionData[assessment.programId].createdBy = s7AssessmentData?.createdBy
            step7CompletionData[assessment.programId].dateCreated = s7AssessmentData?.dateCreated
            step7CompletionData[assessment.programId].modifiedBy = s7AssessmentData?.modifiedBy
            step7CompletionData[assessment.programId].dateModified = s7AssessmentData?.dateModified
        })
        return s7data
    }

    const initStep7Tab2Data = (data) => {
        let s7data = {}
        
        data.programAssessments.forEach((assessment) => {
            if (!(assessment.programId in s7data)) {
                s7data[assessment.programId] = {}
            }
            let s7AssessmentData = assessment.step7Data
            if (s7AssessmentData?.finalReflection) {
                let sData = s7data[assessment.programId]
                sData.s7q1 = s7AssessmentData.finalReflection.themeLessonsLearned
                sData.s7q2 = s7AssessmentData.finalReflection.longTermProgramChanges
                sData.s7q3 = s7AssessmentData.finalReflection.studentAchievementChanges
                sData.s7q4 = s7AssessmentData.finalReflection.externalFactors
            }
            
            if (!(assessment.programId in step7Tab2CompletionData)) {
                step7Tab2CompletionData[assessment.programId] = {}
            }
            let tmpFinalReflection = s7AssessmentData?.finalReflection
            if (tmpFinalReflection) {
                step7Tab2CompletionData[assessment.programId].completed = tmpFinalReflection.completed
                step7Tab2CompletionData[assessment.programId].dateCompleted = tmpFinalReflection.dateCompleted
                step7Tab2CompletionData[assessment.programId].completedBy = tmpFinalReflection.completedBy
            } else {
                step7Tab2CompletionData[assessment.programId].completed = ""
                step7Tab2CompletionData[assessment.programId].dateCompleted = ""
                step7Tab2CompletionData[assessment.programId].completedBy = ""
            }
            
        })
        
        return s7data
    }

    const onProgramChanged = (event) => {
        let programId = event.target.name
        let newPrograms = {...activePrograms}
        if (event.target.value === "yes") {
            newPrograms[programId] = event.target.value
        } else if (event.target.value === "no") {
            newPrograms[programId] = event.target.value
        } else {
            if (newPrograms.hasOwnProperty(programId)) {
                let newSubmittedPrograms = {...submittedPrograms}
                let newSubmittedUsers = {...submittedUsers}
                let newSubmittedDates = {...submittedDates}

                delete newSubmittedPrograms[programId]
                delete newSubmittedUsers[programId]
                delete newSubmittedDates[programId]

                setSubmittedPrograms({...newSubmittedPrograms})
                setSubmittedUsers({...newSubmittedUsers})
                setSubmittedDates({...newSubmittedDates})
            }
        }
        setActivePrograms({...newPrograms})
    }

    const previousStep = () => {
        if (currentStep == STEP_STEP_1) {
            setCurrentStep(STEP_STEP_0)
        } else if (currentStep > STEP_STEP_1) {
            setCurrentStep(step => step - 1)
        }
    }

    const nextStep = () => {
        if (currentStep < STEP_STEP_7) {
            setCurrentStep(step => step + 1)
        } else if (currentStep == STEP_STEP_7) {
            setCurrentStep(STEP_STEP_0)
        }
    }

    const disableNextButton = () => {
        if (currentStep == STEP_SELECT_PROGRAMS) {
            let valid = false
            for (const [key,value] of Object.entries(activePrograms)) {
                if (value === 'yes') {
                    valid = true
                    break
                }
            }
            return !(valid)
        }
        return false
    }

    const onStepCompleted = (e) => {
        let tokens = e.target.id.split('_')
        let programId = tokens[0].split('-')[1]
        let step = tokens[1].split('-')[1]
        const dt = new Date()
        
        if (step === "1") {
            let tmpStep1CompletionData = {...step1CompletionData}
            if (!(programId in tmpStep1CompletionData)) {
                tmpStep1CompletionData[programId] = {
                    completed: e.target.checked,
                    dateCompleted: dt.toISOString(),
                    completedBy: currentUser,
                }
            } else {
                tmpStep1CompletionData[programId].completed = e.target.checked
                tmpStep1CompletionData[programId].dateCompleted = dt.toISOString()
                tmpStep1CompletionData[programId].completedBy = currentUser
            }
            setStep1CompletionData(tmpStep1CompletionData)
        } else if (step === "2") {
            let tmpStep2CompletionData = {...step2CompletionData}
            if (!(programId in tmpStep2CompletionData)) {
                tmpStep2CompletionData[programId] = {
                    completed: e.target.checked,
                    dateCompleted: dt.toISOString(),
                    completedBy: currentUser,
                }
            } else {
                tmpStep2CompletionData[programId].completed = e.target.checked
                tmpStep2CompletionData[programId].dateCompleted = dt.toISOString()
                tmpStep2CompletionData[programId].completedBy = currentUser
            }
            setStep2CompletionData(tmpStep2CompletionData)
        } else if (step === "3") {
            let tmpStep3CompletionData = {...step3CompletionData}
            if (!(programId in tmpStep3CompletionData)) {
                tmpStep3CompletionData[programId] = {
                    completed: e.target.checked,
                    dateCompleted: dt.toISOString(),
                    completedBy: currentUser,
                }
            } else {
                tmpStep3CompletionData[programId].completed = e.target.checked
                tmpStep3CompletionData[programId].dateCompleted = dt.toISOString()
                tmpStep3CompletionData[programId].completedBy = currentUser
            }
            setStep3CompletionData(tmpStep3CompletionData)
        } else if (step === "4") {
            let tmpStep4CompletionData = {...step4CompletionData}
            if (!(programId in tmpStep4CompletionData)) {
                tmpStep4CompletionData[programId] = {
                    completed: e.target.checked,
                    dateCompleted: dt.toISOString(),
                    completedBy: currentUser,
                }
            } else {
                tmpStep4CompletionData[programId].completed = e.target.checked
                tmpStep4CompletionData[programId].dateCompleted = dt.toISOString()
                tmpStep4CompletionData[programId].completedBy = currentUser
            }
            setStep4CompletionData(tmpStep4CompletionData)
        } else if (step === "5") {
            let tmpStep5CompletionData = {...step5CompletionData}
            if (!(programId in tmpStep5CompletionData)) {
                tmpStep5CompletionData[programId] = {
                    completed: e.target.checked,
                    dateCompleted: dt.toISOString(),
                    completedBy: currentUser,
                }
            } else {
                tmpStep5CompletionData[programId].completed = e.target.checked
                tmpStep5CompletionData[programId].dateCompleted = dt.toISOString()
                tmpStep5CompletionData[programId].completedBy = currentUser
            }
            setStep5CompletionData(tmpStep5CompletionData)
        } else if (step === "6") {
            let tmpStep6CompletionData = {...step6CompletionData}
            if (!(programId in tmpStep6CompletionData)) {
                tmpStep6CompletionData[programId] = {
                    completed: e.target.checked,
                    dateCompleted: dt.toISOString(),
                    completedBy: currentUser,
                }
            } else {
                tmpStep6CompletionData[programId].completed = e.target.checked
                tmpStep6CompletionData[programId].dateCompleted = dt.toISOString()
                tmpStep6CompletionData[programId].completedBy = currentUser
            }
            setStep6CompletionData(tmpStep6CompletionData)
        } else if (step === "7Tab1") {
            let tmpStep7CompletionData = {...step7CompletionData}
            if (!(programId in tmpStep7CompletionData)) {
                tmpStep7CompletionData[programId] = {
                    completed: e.target.checked,
                    dateCompleted: dt.toISOString(),
                    completedBy: currentUser,
                }
            } else {
                tmpStep7CompletionData[programId].completed = e.target.checked
                tmpStep7CompletionData[programId].dateCompleted = dt.toISOString()
                tmpStep7CompletionData[programId].completedBy = currentUser
            }
            setStep7CompletionData(tmpStep7CompletionData)
        } else if (step === "7Tab2") {
            let tmpStep7Tab2CompletionData = {...step7Tab2CompletionData}
            if (!(programId in tmpStep7Tab2CompletionData)) {
                tmpStep7Tab2CompletionData[programId] = {
                    completed: e.target.checked,
                    dateCompleted: dt.toISOString(),
                    completedBy: currentUser,
                }
            } else {
                tmpStep7Tab2CompletionData[programId].completed = e.target.checked
                tmpStep7Tab2CompletionData[programId].dateCompleted = dt.toISOString()
                tmpStep7Tab2CompletionData[programId].completedBy = currentUser
            }
            setStep7Tab2CompletionData(tmpStep7Tab2CompletionData)
        }
    }

    const onStep1DialogSave = (data) => {
        let dirtyStep1DataStore = {...step1DataStore}
        dirtyStep1DataStore[data.program.programId] = data.stepDataStore
        setStep1DataStore({...dirtyStep1DataStore})
    }

    const onStep2DialogSave = (data) => {
        let dirtySloAnalysisStore = {...sloAnalysisStore}
        dirtySloAnalysisStore[data.program.programId] = data.sloAnalysisStore
        setSloAnalysisStore({...dirtySloAnalysisStore})
    }

    const onStep4DialogSave = (data) => {
        let dirtyStep4DataStore = {...step4DataStore}
        dirtyStep4DataStore[data.program.programId] = data.stepDataStore
        setStep4DataStore({...dirtyStep4DataStore})
    }

    const onStep5DialogSave = (data) => {
        let dirtyStep5Tab1DataStore = {...step5Tab1DataStore}
        dirtyStep5Tab1DataStore[data.program.programId] = data.stepTab1DataStore
        setStep5Tab1DataStore({...dirtyStep5Tab1DataStore})
        let dirtyStep5Tab2DataStore = {...step5Tab2DataStore}
        dirtyStep5Tab2DataStore[data.program.programId] = data.stepTab2DataStore
        setStep5Tab2DataStore({...dirtyStep5Tab2DataStore})
    }

    const onStep7DialogSave = (data) => {
        let dirtyStep7Tab1DataStore = {...step7Tab1DataStore}
        dirtyStep7Tab1DataStore[data.program.programId] = data.stepDataStore
        setStep7Tab1DataStore({...dirtyStep7Tab1DataStore})
    }

    const onStep7Tab2QuestionChanged = (e) => {
        let tokens = e.target.name.split('_')
        let programId = tokens[0].split('-')[1]
        let question = "s7" + tokens[1]
        let dirtyStep7Tab2DataStore = {...step7Tab2DataStore}
        if (!(programId in dirtyStep7Tab2DataStore)) {
            dirtyStep7Tab2DataStore[programId] = {}
        }
        dirtyStep7Tab2DataStore[programId][question] = e.target.value
        setStep7Tab2DataStore({...dirtyStep7Tab2DataStore})
    }

    const formatAssessmentDataForPost = () => {
        let appData = {
            departmentId: searchParams.get('d'),
            department: department,
            mappedSlos: mappedSlos,
            programLearningOutcomes: programLearningOutcomes,
            theme: theme,
            activePrograms: activePrograms,
            reviewYear: ASSESSMENT_PERIOD,
            currentUser: currentUser,
            step1DataStore: step1DataStore,
            step2DataStore: sloAnalysisStore,
            step3DataStore: step3DataStore,
            step4DataStore: step4DataStore,
            step5Tab1DataStore: step5Tab1DataStore,
            step5Tab2DataStore: step5Tab2DataStore,
            step6DataStore: step6DataStore,
            step7Tab1DataStore: step7Tab1DataStore,
            step7Tab2DataStore: step7Tab2DataStore,
            step1CompletionData: step1CompletionData,
            step2CompletionData: step2CompletionData,
            step3CompletionData: step3CompletionData,
            step4CompletionData: step4CompletionData,
            step5CompletionData: step5CompletionData,
            step6CompletionData: step6CompletionData,
            step7CompletionData: step7CompletionData,
            step7Tab2CompletionData: step7Tab2CompletionData,
        }
        return formatAssessmentPostData(appData)
    }

    const formatAssessmentDataForPut = () => {
        let appData = {
            assessment: assessment,
            departmentId: department.id,
            department: department,
            mappedSlos: mappedSlos,
            programLearningOutcomes: programLearningOutcomes,
            theme: theme,
            activePrograms: activePrograms,
            reviewYear: ASSESSMENT_PERIOD,
            currentUser: currentUser,
            step1DataStore: step1DataStore,
            step2DataStore: sloAnalysisStore,
            step3DataStore: step3DataStore,
            step4DataStore: step4DataStore,
            step5Tab1DataStore: step5Tab1DataStore,
            step5Tab2DataStore: step5Tab2DataStore,
            step6DataStore: step6DataStore,
            step7Tab1DataStore: step7Tab1DataStore,
            step7Tab2DataStore: step7Tab2DataStore,
            step1CompletionData: step1CompletionData,
            step2CompletionData: step2CompletionData,
            step3CompletionData: step3CompletionData,
            step4CompletionData: step4CompletionData,
            step5CompletionData: step5CompletionData,
            step6CompletionData: step6CompletionData,
            step7CompletionData: step7CompletionData,
            step7Tab2CompletionData: step7Tab2CompletionData,
        }
        return formatAssessmentPutData(appData)
    }

    const saveAssessmentData = () => {
        if (mode === "create") {
            postAssessment()
        } else {
            putAssessment()
        }
    }

    const postAssessment = () => {
        const dt = new Date()
        let departmentAssessment = {
            departmentId: parseInt(searchParams.get('d')),
            reviewYear: ASSESSMENT_PERIOD,
            themeId: theme.themeId,
            programAssessments: formatAssessmentDataForPost(),
            createdBy: currentUser,
            dateCreated: dt.toISOString(),
            modifiedBy: currentUser,
            dateModified: dt.toISOString()
        }
        saveAssessment("post", departmentAssessment, (result) => {
            if (mode === "create") {
                const dataPromise = result.json()
                
                // We only need to do  this for create.
                // Modify, we already have the assessment.
                dataPromise.then(data => {
                    setAssessmentId(data.departmentAssessmentId)
                    setMode("modify")
                })
            }
        })
    }

    const putAssessment = () => {
        const dt = new Date()
        let departmentAssessment = {
            departmentAssessmentId: assessment.departmentAssessmentId,
            departmentId: departmentId,
            reviewYear: ASSESSMENT_PERIOD,
            themeId: theme.themeId,
            programAssessments: formatAssessmentDataForPut(),
            createdBy: assessment.createdBy,
            dateCreated: assessment.dateCreated,
            modifiedBy: currentUser,
            dateModified: dt.toISOString()
        }
        
        saveAssessment("put", departmentAssessment, (result) => {
            // nothing to do but re-set the mode?
            setMode("modify")
        })
    }

    const saveAssessment = (method, departmentAssessment, handler) => {
        let url = FAST_URL + "/assessments"
        if ('departmentAssessmentId' in departmentAssessment) {
         url = `${url}/${departmentAssessment['departmentAssessmentId']}`
        }
        setSaveInProgress(true)
        fetch(url, 
        {
            body: JSON.stringify(departmentAssessment),
            method: method,
            headers: { 'Content-Type': 'application/json' },
        })
        .then(res => {
            setSaveInProgress(false)
            if (res.status == 201 || res.status == 204) {
                setErrorFound(false)
                setErrorMessage("")
                handler(res)
            } else if (res.status == 409) {
                setErrorFound(true)
                setErrorMessage("Your session is not valid. Please refresh the page and try again.")
            } else {
                setErrorFound(true)
                setErrorMessage("Unexpected error saving Assessment data (" + res.status + ")")
            }
            setShowToast(true)
        })
        .catch(err => {
            console.log(err)
            console.log(mode)
            setSaveInProgress(false)
            setErrorFound(true)
            setErrorMessage("Unexpected error saving Assessment data")
            setShowToast(true)
        })
    }

    let step
    if (currentStep === STEP_SELECT_PROGRAMS) {
        step = <AssessmentPrograms
                department={department}
                departmentId={departmentId}
                activePrograms={activePrograms}
                onProgramChanged={onProgramChanged}
                />
    } else {
        if (currentStep === STEP_STEP_0) {
            step = <AssessmentStep0 
                    department={department}
                    activePrograms={activePrograms}
                    setCurrentStep={setCurrentStep}
                    step1CompletionData={step1CompletionData}
                    step2CompletionData={step2CompletionData}
                    step3CompletionData={step3CompletionData}
                    step4CompletionData={step4CompletionData}
                    step5CompletionData={step5CompletionData}
                    step6CompletionData={step6CompletionData}
                    step7CompletionData={step7CompletionData}
                    step7Tab2CompletionData={step7Tab2CompletionData}
                    />
        } else if (currentStep === STEP_STEP_1) {
            step = <AssessmentStep1
                    department={department}
                    departmentId={department.id}
                    activePrograms={activePrograms}
                    theme={theme}
                    learningOutcomes={programLearningOutcomes[department.id].learningOutcomes}
                    mappedSlos={mappedSlos}
                    
                    stepDataStore={step1DataStore}
                    step1CompletionData={step1CompletionData}
                    step2CompletionData={step2CompletionData}
                    onStep1DialogSave={onStep1DialogSave}
                    stepTitle={TITLE_STEP_1}
                    onStepCompleted={onStepCompleted}
                    />
        } else if (currentStep === STEP_STEP_2) {
            step = <AssessmentStep2
                    department={department}
                    departmentId={department.id}
                    activePrograms={activePrograms}
                    theme={theme}
                    learningOutcomes={programLearningOutcomes[department.id].learningOutcomes}
                    mappedSlos={mappedSlos}
                    step1DataStore={step1DataStore}
                    
                    sloAnalysisStore={sloAnalysisStore}
                    step1CompletionData={step1CompletionData}
                    step2CompletionData={step2CompletionData}
                    step3CompletionData={step3CompletionData}
                    handleStep2DialogSave={onStep2DialogSave}
                    stepTitle={TITLE_STEP_2}
                    onStepCompleted={onStepCompleted}
                    />
        } else if (currentStep === STEP_STEP_3) {
            step = <AssessmentStep3
                    department={department}
                    departmentId={department.id}
                    activePrograms={activePrograms}
                    theme={theme}
                    learningOutcomes={programLearningOutcomes[department.id].learningOutcomes}
                    mappedSlos={mappedSlos}
                    stepTitle={TITLE_STEP_3}
                    step3DataStore={step3DataStore}
                    step1CompletionData={step1CompletionData}
                    step2CompletionData={step2CompletionData}
                    step3CompletionData={step3CompletionData}
                    step4CompletionData={step4CompletionData}
                    onStepCompleted={onStepCompleted}
                    />
        } else if (currentStep === STEP_STEP_4) {
            step = <AssessmentStep4
                    department={department}
                    departmentId={department.id}
                    activePrograms={activePrograms}
                    theme={theme}
                    learningOutcomes={programLearningOutcomes[department.id].learningOutcomes}
                    mappedSlos={mappedSlos}
                    step1DataStore={step1DataStore}
                    sloAnalysis={sloAnalysisStore}
                    step2DataStore={sloAnalysisStore}
                    step4DataStore={step4DataStore}
                    step1CompletionData={step1CompletionData}
                    step2CompletionData={step2CompletionData}
                    step3CompletionData={step3CompletionData}
                    step4CompletionData={step4CompletionData}
                    step5CompletionData={step5CompletionData}
                    handleStep4DialogSave={onStep4DialogSave}
                    stepTitle={TITLE_STEP_4}
                    onStepCompleted={onStepCompleted}
                    />
        } else if (currentStep === STEP_STEP_5) {
            step = <AssessmentStep5
                    department={department}
                    departmentId={department.id}
                    activePrograms={activePrograms}
                    theme={theme}
                    learningOutcomes={programLearningOutcomes[department.id].learningOutcomes}
                    mappedSlos={mappedSlos}
                    step1DataStore={step1DataStore}
                    sloAnalysis={sloAnalysisStore}
                    step2DataStore={sloAnalysisStore}
                    step4DataStore={step4DataStore}
                    step5Tab1DataStore={step5Tab1DataStore}
                    step5Tab2DataStore={step5Tab2DataStore}
                    step1CompletionData={step1CompletionData}
                    step2CompletionData={step2CompletionData}
                    step3CompletionData={step3CompletionData}
                    step4CompletionData={step4CompletionData}
                    step5CompletionData={step5CompletionData}
                    step6CompletionData={step6CompletionData}
                    handleStep5DialogSave={onStep5DialogSave}
                    stepTitle={TITLE_STEP_5}
                    onStepCompleted={onStepCompleted}
                    />
        } else if (currentStep === STEP_STEP_6) {
            step = <AssessmentStep6
                    department={department}
                    departmentId={department.id}
                    activePrograms={activePrograms}
                    theme={theme}
                    stepTitle={TITLE_STEP_6}
                    step6DataStore={step6DataStore}
                    step1CompletionData={step1CompletionData}
                    step2CompletionData={step2CompletionData}
                    step3CompletionData={step3CompletionData}
                    step4CompletionData={step4CompletionData}
                    step5CompletionData={step5CompletionData}
                    step6CompletionData={step6CompletionData}
                    step7CompletionData={step7CompletionData}
                    onStepCompleted={onStepCompleted}
                    />
        } else if (currentStep === STEP_STEP_7) {
            step = <AssessmentStep7
                    department={department}
                    departmentId={department.id}
                    activePrograms={activePrograms}
                    theme={theme}
                    learningOutcomes={programLearningOutcomes[department.id].learningOutcomes}
                    mappedSlos={mappedSlos}
                    step1DataStore={step1DataStore}
                    sloAnalysis={sloAnalysisStore}
                    step2DataStore={sloAnalysisStore}
                    step4DataStore={step4DataStore}
                    step5Tab1DataStore={step5Tab1DataStore}
                    step5Tab2DataStore={step5Tab2DataStore}

                    step7Tab1DataStore={step7Tab1DataStore}
                    step7Tab2DataStore={step7Tab2DataStore}
                    step1CompletionData={step1CompletionData}
                    step2CompletionData={step2CompletionData}
                    step3CompletionData={step3CompletionData}
                    step4CompletionData={step4CompletionData}
                    step5CompletionData={step5CompletionData}
                    step6CompletionData={step6CompletionData}
                    step7CompletionData={step7CompletionData}
                    step7Tab2CompletionData={step7Tab2CompletionData}
                    handleStep7DialogSave={onStep7DialogSave}
                    onStep7Tab2QuestionChanged={onStep7Tab2QuestionChanged}
                    stepTitle={TITLE_STEP_7}
                    onStepCompleted={onStepCompleted}
                    />
        } else if (currentStep == STEP_STEP_8) {
            step = <AssessmentSubmit
                    mode={mode}
                    />
        }
    }

    return (
        <React.Fragment>
            <div>
                {step}
                
                { (SAVE_ON_NEXT_ENABLED === true && currentStep >= STEP_STEP_0 && currentStep < STEP_STEP_8) &&
                    <div className="mx-auto col-md-6 px-1 pb-5 w-100">
                        <Container fluid>
                            <Row>
                                <Col
                                    md={{span: 8, offset: 3}}
                                    lg={{span: 12, offset: 4}}
                                    >
                                    <Form.Check 
                                        label="Checking this box will save your changes when clicking 'Next'"
                                        />
                                </Col>
                            </Row>
                        </Container>
                    </div>
                }

                { (SAVE_ON_NEXT_ENABLED === false && currentStep >= STEP_STEP_0 && currentStep < STEP_STEP_8) &&
                    <div className="mx-auto col-md-6 px-1 pb-5 w-100">
                        <Container fluid>
                            <Row>
                                <Col className="text-center">
                                    <span>{ SAVE_REMINDER_MESSAGE }</span>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                }

                {(currentStep <= STEP_STEP_7) &&
                    <div className="form-button-group text-center">
                        { currentStep > STEP_STEP_0 &&
                            <span className="col-md-6 px-1">
                                <Button
                                    onClick={previousStep}
                                    variant="primary"
                                    size="md"
                                    >
                                    Back
                                </Button>
                            </span>
                        }
                        
                        { currentStep > STEP_STEP_0 &&
                            <span className="col-md-6 px-1">
                                <Button
                                    onClick={() => setCurrentStep(1)}
                                    variant="secondary"
                                    size="md"
                                    >
                                    Home
                                </Button>
                            </span>
                        }
                        { currentStep >= STEP_STEP_0 && 
                            <span className="col-md-6 px-1">
                            <Button
                                size="md"
                                onClick={saveAssessmentData}
                                disabled={saveInProgress}
                                >
                                {saveInProgress ? (
                                    <>
                                        Saving...
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className="ms-2"
                                        />
                                    </>
                                ) : (
                                    'Save'
                                )}
                                
                            </Button>
                            </span>
                        }
                        { (currentStep == STEP_SELECT_PROGRAMS || (currentStep > STEP_STEP_0 && currentStep <= STEP_STEP_7)) &&
                            <span className="col-md-6 px-1">
                                <Button
                                    onClick={nextStep}
                                    disabled={disableNextButton()}
                                    size="md"
                                    >
                                    Next
                                </Button>
                            </span>
                        }
                        
                    </div>
                }
                <ToastContainer position="top-end">
                    <Toast
                        bg={errorFound ? `danger` : `secondary`}
                        delay={errorFound ? 6000: 4000}
                        show={showToast}
                        onClose={() => {
                            setShowToast(false)
                        }}
                        autohide
                        >
                        <Toast.Header>
                            <strong className="me-auto">FAsT Assessment Save</strong>
                            <small>Now</small>
                        </Toast.Header>
                        <Toast.Body className="text-white">
                            {errorFound ? `${errorMessage}` : `Assessment Saved`}
                        </Toast.Body>
                    </Toast>
                </ToastContainer>
            </div>
        </React.Fragment>
    )
}